module.exports = __webpack_public_path__ + "img/software_manage.1017c2ba.png";